export const getMonthName = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', { month: 'long', year: 'numeric' });
};

export const getWorkingDaysInMonth = (dateString) => {
  const date = new Date(dateString);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  if (lastDay === 28) return 20;
  if (lastDay === 29) return 21;
  if (lastDay === 30) return 22;
  if (lastDay === 31) return 23;
  return 22;
};

export const calculateOvertimeHours = (startTime, endTime) => {
  try {
    const [startH, startM] = startTime.split(':').map(Number);
    const [endH, endM] = endTime.split(':').map(Number);
    
    const startMin = startH * 60 + startM;
    let endMin = endH * 60 + endM;
    
    // Если время окончания меньше времени начала, значит работали через полночь
    if (endMin < startMin) {
      endMin += 24 * 60; // добавляем 24 часа
    }
    
    let overtimeMin = 0;
    
    // Переработка до 9:00 (540 минут)
    if (startMin < 540) {
      const endBeforeWork = Math.min(endMin, 540);
      overtimeMin += Math.max(0, endBeforeWork - startMin);
    }
    
    // Переработка после 18:00 (1080 минут)
    if (endMin > 1080) {
      const startAfterWork = Math.max(startMin, 1080);
      overtimeMin += Math.max(0, endMin - startAfterWork);
    }
    
    return parseFloat((overtimeMin / 60).toFixed(2));
  } catch {
    return 0;
  }
};

export const calculateTotalHours = (startTime, endTime) => {
  try {
    const [startH, startM] = startTime.split(':').map(Number);
    const [endH, endM] = endTime.split(':').map(Number);
    
    let startTotal = startH * 60 + startM;
    let endTotal = endH * 60 + endM;
    
    // Если время окончания меньше времени начала, значит работали через полночь
    if (endTotal < startTotal) {
      endTotal += 24 * 60;
    }
    
    const diffMin = endTotal - startTotal;
    return parseFloat((diffMin / 60).toFixed(2));
  } catch {
    return 0;
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return 'Неизвестно';
  const date = new Date(dateString);
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};